import { combineReducers } from 'redux';
import orders from './reducers/ordersReducers';
import cachedOrders from './reducers/orderCacheReducer';
import order from './reducers/orderReducer';
import todaysTasks from './reducers/todaysTasksReducer';
import tasksByOrder from './reducers/tasksByOrderReducer';
import tasksStatusCount from './reducers/tasksStatusCountReducer';
import productionData from './reducers/productionDataReducer';
import productionDataTools from './reducers/productionDataReducerTools';
import qualityControlData from './reducers/qualityControlDataReducer';
import tasks from './reducers/tasksReducer';
import comments from './reducers/commentsReducer';
import notification from './reducers/notificationReducer';
import threads from './reducers/threadsReducer';
import singleThread from './reducers/singleThreadReducer';
import steps from './reducers/stepsReducer';
import users from './reducers/usersReducer';
import auth from './reducers/authReducer';
import usersByOrder from './reducers/usersByOrderReducer';
import costSheet from './reducers/costSheetReducer';
import rfq from './reducers/rfqReducer';
import rfqQuries from './reducers/rfqQuriesReducer';
import btb from './reducers/btbReducer';
import primaryRawMaterial from './reducers/primaryRawMaterialReducer';
import accessories from './reducers/accessoriesReducer';
import commission from './reducers/commissionReducer';
import reports from './reducers/reportsReducer';
import options from './reducers/optionsReducer';
import dashboard from './reducers/dashboardReducer';
import toolsReportData from './reducers/toolsReportDataReducer';
import costSheets from './reducers/toolsCostSheetReducer';
import materials from './reducers/materialsReducer';
import notes from './reducers/noteReducer';
import contacts from './reducers/contactReducer';
import message from './reducers/messageReducer';
import rfqmessage from './reducers/rfqmessageReducer';
import activeChat from './reducers/activeChatReducer';
import generalInformation from './trims/reducer/generalInformationReducer';
import configuration from './trims/reducer/configurationReducer';
import challan from './trims/reducer/challanRuducer';
import itemSpecification from './trims/reducer/itemSpecificationReducer';
import orderStep from './trims/reducer/orderStepReducer';
import mainSpecificationReducer from './trims/reducer/mainSpecificationReducer';
import colorFrontSideReducer from './trims/reducer/colorFrontSideReducer';
import colorBackSideReducer from './trims/reducer/colorBackSideReducer';
import qcData from './trims/reducer/qcReducer';
import accountData from './trims/reducer/accountReducer';
import customerOrders from './trims/reducer/customerOrderReducer';
import production from './trims/reducer/productionReducer';

const reducers = combineReducers({
  accessories,
  auth,
  btb,
  materials,
  costSheets,
  dashboard,
  options,
  comments,
  commission,
  toolsReportData,
  costSheet,
  notification,
  order,
  orders,
  primaryRawMaterial,
  productionData,
  productionDataTools,
  qualityControlData,
  rfq,
  rfqQuries,
  reports,
  singleThread,
  steps,
  tasks,
  tasksByOrder,
  tasksStatusCount,
  threads,
  todaysTasks,
  users,
  usersByOrder,
  notes,
  contacts,
  message,
  rfqmessage,
  activeChat,
  generalInformation,
  configuration,
  challan,
  itemSpecification,
  orderStep,
  mainSpecificationReducer,
  colorFrontSideReducer,
  colorBackSideReducer,
  qcData,
  accountData,
  customerOrders,
  production,
  cachedOrders,
});

export default reducers;
